import useQuery from "../../Hooks/useQuery";
import OrderDetails from "../OrderDetails/OrderDetails";
import OrdersList from "./OrdersList";

const OrdersWrapper = () => {
  const query = useQuery();
  const id = query.get("id");

  return id && id !== "" ? <OrderDetails /> : <OrdersList />;
};

export default OrdersWrapper;
